/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_XlsxInputs */

const en_gc_resources_features_xlsx = /** @type {(inputs: Gc_Resources_Features_XlsxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XLSX is the native file format.`)
};

const zh_gc_resources_features_xlsx = /** @type {(inputs: Gc_Resources_Features_XlsxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原生使用 XLSX 文件格式。`)
};

/**
* | output |
* | --- |
* | "XLSX is the native file format." |
*
* @param {Gc_Resources_Features_XlsxInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_xlsx = /** @type {((inputs?: Gc_Resources_Features_XlsxInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_XlsxInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_xlsx(inputs)
	return zh_gc_resources_features_xlsx(inputs)
});
export { gc_resources_features_xlsx as "gc.resources.features.xlsx" }